import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../Pages/Login";
import Dashboard from "../Pages/Dashboard";
import ForgetPassword from "../Pages/ForgetPassword";
import ResetPassword from "../Pages/ResetPassword";
import { AppStorage } from "../Utils/Context/AppContext";
import { Box, CircularProgress } from "@mui/material";
import MaintenancePage from "../Pages/MaintenancePage";

function Main() {
  const { isLoading, maintenanceModeActive, maintenanceChecked } = useContext(AppStorage);
  const token = localStorage.getItem("p_u_t");

  if (isLoading || !maintenanceChecked) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (token && maintenanceModeActive) return <MaintenancePage />;

  return (
    <>
      <Routes>
        {!token ? (
          <>
            <Route path="/" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/password-reset" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to={"/"} />} />
          </>
        ) : (
          <>
            <Route path="/*" element={<Dashboard />} />
            
            <Route path="/" element={<Navigate to={"/invoices"} />} />
          </>
        )}
      </Routes>
    </>
  );
}

export default Main;
